export const REGISTER = 'register';
export const REGISTRATION = 'registration';
export const LOGIN = 'login';
export const REQUEST_PASSWORD_EMAIL = 'request-password-email';
export const RESET_PASSWORD = 'reset-password';
export const UPDATE_PASSWORD = 'update-password';
export const SOCIAL_ACCOUNT_LINKED = 'social-account-linked';
export const AUTO_PROMPT_REGISTER = 'AUTO_PROMPT_REGISTER';
export const SOCIAL_CASE_CONNECTION_LINKED = 'LINKED_SOCIAL_CONNECTION';
export const SOCIAL_CASE_ACCOUNT_CREATED = 'Created';
export const SOCIAL_CASE_NO_EMAIL_RETURNED = 'NO_EMAIL_RETURNED';
export const SOCIAL_CASE_TOKEN_EXPIRED = 'SOCIAL_CASE_TOKEN_EXPIRED';
// types of auth consumption
export const AUTH_CONTENT = 'AUTH_CONTENT'; // auth injected as content
export const AUTH_MODAL = 'AUTH_MODAL'; // auth loaded as modal

// login and registration flows
export const DEFAULT_FLOW = 'DEFAULT_FLOW';
export const DEFAULT_UNAUTH_FLOW = 'DEFAULT_UNAUTH_FLOW';
export const PAGEVIEW_LIMIT_FLOW = 'PAGEVIEW_LIMIT_FLOW';
export const COMPLETE_EMAIL_ONLY_FLOW = 'COMPLETE_EMAIL_ONLY_FLOW';
export const CONTACT_DEALER_FLOW = 'CONTACT_DEALER_FLOW';
export const FULL_ACCOUNT_CONTACT_DEALER_FLOW = 'FULL_ACCOUNT_CONTACT_DEALER_FLOW';
export const PASSWORD_ONLY_CONTACT_DEALER_FLOW = 'PASSWORD_ONLY_CONTACT_DEALER_FLOW';
export const CALL_DEALER_FLOW = 'CALL_DEALER_FLOW';
export const CONSULT_AN_EXPERT_FLOW = 'CONSULT_AN_EXPERT_FLOW';
export const PASSWORD_ONLY_CONSULT_AN_EXPERT_FLOW = 'PASSWORD_ONLY_CONSULT_AN_EXPERT_FLOW';
export const PASSWORD_ONLY_FULL_ACCOUNT_CONTACT_DEALER_FLOW =
    'PASSWORD_ONLY_FULL_ACCOUNT_CONTACT_DEALER_FLOW';
export const CONTACT_DEALER_FORM_FLOW = 'CONTACT_DEALER_FORM_FLOW';
export const EMBEDDED_CHECKOUT_FLOW = 'EMBEDDED_CHECKOUT_FLOW';
export const FOLLOW_DEALER_FLOW = 'FOLLOW_DEALER_FLOW';
export const SAVE_ITEM_FLOW = 'SAVE_ITEM_FLOW';
export const SAVE_ITEM_TO_FOLDER_FLOW = 'SAVE_ITEM_TO_FOLDER_FLOW';
export const STALE_LOGIN_FLOW = 'STALE_LOGIN_FLOW';
export const STALE_LOGIN_CHECKOUT_FLOW = 'STALE_LOGIN_CHECKOUT_FLOW';
export const EMAIL_ONLY_ALT_REGISTRATION_TRADE_FLOW = 'EMAIL_ONLY_ALT_REGISTRATION_TRADE_FLOW';
export const EMAIL_ONLY_TRADE_APPLICATION_FLOW = 'EMAIL_ONLY_TRADE_APPLICATION_FLOW';
export const TRADE_APPLICATION_FLOW = 'TRADE_APPLICATION_FLOW';
export const ALT_REGISTRATION_TRADE_FLOW = 'ALT_REGISTRATION_TRADE_FLOW';
export const ALT_REGISTRATION_CONSUMER_FLOW = 'ALT_REGISTRATION_CONSUMER_FLOW';
export const SAVE_ITEM_PDP_FLOW = 'SAVE_ITEM_PDP_FLOW';
export const REQUEST_SHIPPING_FLOW = 'REQUEST_SHIPPING_FLOW';
export const BENEFITS_MODAL_FLOW = 'BENEFITS_MODAL_FLOW';
export const DESIGNER_CONNECTION_MODAL_FLOW = 'DESIGNER_CONNECTION_MODAL_FLOW';
export const DISCOVER_FEED_FLOW = 'DISCOVER_FEED_FLOW';
export const SAVE_SUBSCRIPTION_PREFERENCES_FLOW = 'SAVE_SUBSCRIPTION_PREFERENCES_FLOW';
export const AUTO_MODAL_ABANDONED_CHECKOUT_FLOW = 'AUTO_MODAL_ABANDONED_CHECKOUT_FLOW';
export const AUTO_MODAL_PDP_FLOW = 'AUTO_MODAL_PDP_FLOW';
export const LOGGED_OUT_TRADE_FLOW = 'LOGGED_OUT_TRADE_FLOW';
export const MAKE_OFFER_FLOW = 'MAKE_OFFER_FLOW';
export const ORDER_LOOKUP_FLOW = 'ORDER_LOOKUP_FLOW';
export const FOLLOW_SEARCH_BANNER_FLOW = 'FOLLOW_SEARCH_BANNER_FLOW';
// order action flows
export const DEFAULT_ORDER_ACTION_FLOW = 'DEFAULT_ORDER_ACTION_FLOW';
export const CONTACT_DEALER_ORDER_ACTION_FLOW = 'CONTACT_DEALER_ORDER_ACTION_FLOW';
export const ACCEPT_OFFER_ORDER_ACTION_FLOW = 'ACCEPT_OFFER_ORDER_ACTION_FLOW';
export const COUNTER_OFFER_ORDER_ACTION_FLOW = 'COUNTER_OFFER_ORDER_ACTION_FLOW';
export const COMPLETE_PURCHASE_ORDER_ACTION_FLOW = 'COMPLETE_PURCHASE_ORDER_ACTION_FLOW';
export const CANCEL_ORDER_ORDER_ACTION_FLOW = 'CANCEL_ORDER_ORDER_ACTION_FLOW';
export const PASS_ON_OFFER_ORDER_ACTION_FLOW = 'PASS_ON_OFFER_ORDER_ACTION_FLOW';
export const CLAIM_ORDER_FLOW = 'CLAIM_ORDER_FLOW';
export const BOMT_CLAIM_ORDER_FLOW = 'BOMT_CLAIM_ORDER_FLOW';

// Log in with email token
export const LOGIN_EMAIL_TOKEN_DEFAULT_FLOW = 'LOGIN_EMAIL_TOKEN_DEFAULT_FLOW';
export const LOGIN_EMAIL_TOKEN_MY_ORDERS_FLOW = 'LOGIN_EMAIL_TOKEN_MY_ORDERS_FLOW';
export const LOGIN_EMAIL_TOKEN_MY_CONVERSATIONS_FLOW = 'LOGIN_EMAIL_TOKEN_MY_CONVERSATIONS_FLOW';

// forgot password flows (modal which sends reset password email)
export const EMAIL_ONLY_CREATE_PASSWORD_FLOW = 'EMAIL_ONLY_CREATE_PASSWORD_FLOW';
export const RESET_INVALID_RESET_PASSWORD_FLOW = 'RESET_INVALID_RESET_PASSWORD_FLOW';

// reset password + reset invalid flows (modal which allows inline reset of password)
export const DEFAULT_RESET_PASSWORD_FLOW = 'DEFAULT_RESET_PASSWORD_FLOW';
export const CREATE_PASSWORD_MY_ACCOUNT_FLOW = 'CREATE_PASSWORD_MY_ACCOUNT_FLOW';
export const CREATE_PASSWORD_VIEW_SHIPPING_MC_FLOW = 'CREATE_PASSWORD_VIEW_SHIPPING_MC_FLOW';
export const CREATE_PASSWORD_MUTE_CONVERSATION_FLOW = 'CREATE_PASSWORD_MUTE_CONVERSATION_FLOW';
export const CREATE_PASSWORD_MY_CONVERSATIONS_FLOW = 'CREATE_PASSWORD_MY_CONVERSATIONS_FLOW';
export const CREATE_PASSWORD_MY_ORDERS_FLOW = 'CREATE_PASSWORD_MY_ORDERS_FLOW';
export const CREATE_PASSWORD_ACCEPT_OFFER_FLOW = 'CREATE_PASSWORD_ACCEPT_OFFER_FLOW';
export const CREATE_PASSWORD_CHECKOUT_FLOW = 'CREATE_PASSWORD_CHECKOUT_FLOW';
export const CREATE_PASSWORD_REQUEST_SHIPPING_MC_FLOW = 'CREATE_PASSWORD_REQUEST_SHIPPING_MC_FLOW';
export const CREATE_PASSWORD_INVOICE_FLOW = 'CREATE_PASSWORD_INVOICE_FLOW';
export const CREATE_PASSWORD_CALL_SELLER_FLOW = 'CREATE_PASSWORD_CALL_SELLER_FLOW';

// existing email only users flows
export const COMPLETE_SIGNUP_VERIFY_EMAIL_FLOW = 'COMPLETE_SIGNUP_VERIFY_EMAIL_FLOW';
export const DEFAULT_VERIFY_EMAIL_FLOW = 'DEFAULT_VERIFY_EMAIL_FLOW';

// close reasons
export const CLOSE = 'closed';
export const PAUSE_AUTH_FLOW = 'PAUSE_AUTH_FLOW';
export const CLOSED_BY_CONSUMER = 'CLOSED_BY_CONSUMER';

// flows which have specific handling for the verify email flow
export const verifyEmailFlows = [
    CONTACT_DEALER_FLOW,
    SAVE_ITEM_FLOW,
    SAVE_ITEM_PDP_FLOW,
    SAVE_ITEM_TO_FOLDER_FLOW,
    FOLLOW_DEALER_FLOW,
    MAKE_OFFER_FLOW,
    COMPLETE_SIGNUP_VERIFY_EMAIL_FLOW,
    DEFAULT_VERIFY_EMAIL_FLOW,
    DEFAULT_ORDER_ACTION_FLOW,
    CONTACT_DEALER_ORDER_ACTION_FLOW,
    ACCEPT_OFFER_ORDER_ACTION_FLOW,
    COUNTER_OFFER_ORDER_ACTION_FLOW,
    COMPLETE_PURCHASE_ORDER_ACTION_FLOW,
    CANCEL_ORDER_ORDER_ACTION_FLOW,
    PASS_ON_OFFER_ORDER_ACTION_FLOW,
    CLAIM_ORDER_FLOW,
    BOMT_CLAIM_ORDER_FLOW,
];
